// extracted by mini-css-extract-plugin
export default {"container":"PageRange_container__XYkaC"};